import { render, staticRenderFns } from "./FilesViewer.vue?vue&type=template&id=2adb7ad1"
import script from "./FilesViewer.vue?vue&type=script&lang=js"
export * from "./FilesViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports